<template>
    <Layout>
        <template v-slot:title>
            <h1>Activity Logs</h1>
        </template>

        <template v-slot:content>
            <Loader v-if="isLoading"></Loader>

            <div class="row mb-2">
                <div class="col-sm-6 col-md-4 col-xl-3 mb-2 mb-md-0">
                    <DatePicker
                        v-model="filterDate"
                        @clear="filterDate = null"
                        placeholder="Select date range"
                        format="YYYY-MM-DD"
                        value-type="format"
                        type="date"
                        range
                    ></DatePicker>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3 mb-2 mb-md-0">
                    <select class="form-control" v-model="filterType">
                        <option value="">Filter by type</option>
                        <option :value="item.value" :key="index" v-for="(item, index) in logTypes">
                            {{ item.label }}
                        </option>
                    </select>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3">
                    <form @submit.prevent="onSearch" class="input-group btn-inline">
                        <input v-model="keyword" type="text" class="form-control float-right" placeholder="Search" />

                        <div class="input-group-append">
                            <button type="submit" class="btn btn-default">
                                <f-icon icon="search" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mb-2 border-0">
                <div
                    v-for="(item, index) in dashboard.filter(e => e.show === true)"
                    :key="index"
                    :class="{
                        'col-lg-3': dashboard.filter(e => e.show === true).length === 4,
                        'col-lg-6': dashboard.filter(e => e.show === true).length === 2,
                        'col-sm-12 my-2': true
                    }"
                >
                    <DashboardCard :color="item.color" class="h-100">
                        <template slot="icon">
                            <ArchiveIcon v-if="item.icon == 'archive'" size="1.5x" class="custom-class"></ArchiveIcon>
                            <RadioIcon v-if="item.icon == 'radio'" size="1.5x" class="custom-class"></RadioIcon>
                            <CheckCircleIcon
                                v-if="item.icon == 'check-circle'"
                                size="1.5x"
                                class="custom-class"
                            ></CheckCircleIcon>
                            <XCircleIcon v-if="item.icon == 'x-circle'" size="1.5x" class="custom-class"></XCircleIcon>
                        </template>
                        <template slot="title">
                            <span>{{ item.title }}</span>
                        </template>
                        <template slot="total">
                            <h3 class="total-score mb-0 font-weight-bold d-inline-block">
                                {{ item.total }}
                            </h3>
                        </template>
                        <template slot="description">{{ item.description }}</template>
                    </DashboardCard>
                </div>
            </div>
            <div v-if="list.length > 0">
                <ul class="list-group custom-list-group mb-3">
                    <li :key="index" v-for="(item, index) in list" class="list-group-item d-flex flex-wrap">
                        <span class="d-flex align-items-center mr-3">
                            <ClockIcon size="1.1x" class="mr-1"></ClockIcon>
                            <span>{{ item.created_at }}</span>
                        </span>
                        <span v-html="item.message" :style="{ color: getColor(item.type) }"></span>
                    </li>
                </ul>
                <Paginator
                    @change="onPageChange"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    :total-items="totalItems"
                    :items-per-page="itemsPerPage"
                />
            </div>
            <EmptyList v-else :label="emptyLabel" />
        </template>
    </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import Loader from '@/components/Loader'
import EmptyList from '@/components/EmptyList'
import Paginator from '@/components/Paginator'
import { ClockIcon } from 'vue-feather-icons'
import Url from '@/service/url'
import DatePicker from 'vue2-datepicker'
import appConfig from '../../app.config.js'
import DashboardCard from '@/components/dashboard/Card'
import { ArchiveIcon, RadioIcon, CheckCircleIcon, XCircleIcon } from 'vue-feather-icons'
import helpers from '@/service/helpers'

export default {
    name: 'log-index',

    components: {
        Layout,
        Loader,
        EmptyList,
        ClockIcon,
        Paginator,
        DatePicker,
        DashboardCard,
        ArchiveIcon,
        RadioIcon,
        CheckCircleIcon,
        XCircleIcon
    },

    data() {
        return {
            isLoading: false,
            list: [],

            currentPage: 1,
            pageCount: 0,
            totalItems: 0,

            keyword: '',
            filterDate: null,
            filterType: '',

            logTypes: [],
            itemsPerPage: 200,

            emptyLabel: 'No data in list.',

            dashboard: [
                {
                    color: 'blue',
                    icon: 'archive',
                    title: 'Total',
                    total: 0,
                    description: 'Total of Logs',
                    show: true
                },
                {
                    color: 'orange',
                    icon: 'radio',
                    title: 'User Start Quiz',
                    total: 0,
                    description: 'Total of the last 7 days',
                    show: false
                },
                {
                    color: 'green',
                    icon: 'check-circle',
                    title: 'Quiz Finish',
                    total: 0,
                    description: 'Total of the last 7 days',
                    show: false
                },
                {
                    color: 'red',
                    icon: 'x-circle',
                    title: 'Quiz Not Finish',
                    total: 0,
                    description: 'Total of the last 7 days',
                    show: false
                }
            ]
        }
    },

    watch: {
        $route() {
            const url = new Url()

            this.selectedStatus = ''

            this.findMany(url.buildQuery())
        },

        filterDate() {
            this.onSearch()
        },

        filterType() {
            this.onSearch()
        }
    },

    mounted() {
        this.logTypes = appConfig.log_type
        this.findMany()
    },

    methods: {
        ...helpers,

        getColor(type) {
            if (['user_create_quiz', 'quiz_finish'].indexOf(type) > -1) {
                return 'green'
            }

            if (['user_update_quiz'].indexOf(type) > -1) {
                return 'teal'
            }

            if (['user_added_credit', 'user_added_coin', 'user_removed_credit'].indexOf(type) > -1) {
                return 'purple'
            }

            if (['user_buy_player_by_paypal'].indexOf(type) > -1) {
                return '#1f264f'
            }

            if (['buy_player_by_stripe'].indexOf(type) > -1) {
                return '#6772e5'
            }

            if (['user_register_normal', 'user_register_with_3rd_party'].indexOf(type) > -1) {
                return 'blue'
            }

            if (['user_start_quiz'].indexOf(type) > -1) {
                return 'orange'
            }

            if (['user_suspend', 'user_leave_quiz'].indexOf(type) > -1) {
                return 'red'
            }

            if (['live_quiz_survey'].indexOf(type) > -1) {
                return '#003df4'
            }
        },

        async findMany() {
            const url = new Url()
            const query = url.buildQuery()

            this.isLoading = true

            const findData = await this.$store.dispatch('log/findMany', query)
            if (findData.status === 200) {
                const logs = findData.data.data

                this.list = logs.data

                this.pageCount = logs.page_count
                this.totalItems = logs.total
                this.currentPage = parseFloat(logs.current_page)
                this.keyword = query.keyword
                this.filterDate = query.date ? query.date : null
                this.filterType = query.type ? query.type : ''

                if (this.filterType == 'user_start_quiz') {
                    this.dashboard[1].show = true
                    this.dashboard[2].show = false
                    this.dashboard[3].show = false
                } else if (this.filterType == 'quiz_finish') {
                    this.dashboard[1].show = false
                    this.dashboard[2].show = true
                    this.dashboard[3].show = false
                } else if (this.filterType == 'quiz_not_finish') {
                    this.dashboard[1].show = false
                    this.dashboard[2].show = false
                    this.dashboard[3].show = true
                } else {
                    this.dashboard[1].show = true
                    this.dashboard[2].show = true
                    this.dashboard[3].show = true
                }

                // Count data
                const countAllType = await this.countAllType(this.filterDate, this.filterType)
                if (countAllType.status === 200) {
                    const countData = countAllType.data.data

                    // Dashboard
                    this.dashboard[0].total = logs.total
                    this.dashboard[1].total = countData.user_start_quiz
                    this.dashboard[2].total = countData.quiz_finish
                    this.dashboard[3].total = countData.quiz_not_finish

                    this.filterDate = !this.filterDate ? null : this.filterDate.filter(date => date)

                    if (this.filterDate) {
                        this.dashboard[0].description = `Total of ${this.filterDate[0]} to ${this.filterDate[1]}`
                        this.dashboard[1].description = `Total of ${this.filterDate[0]} to ${this.filterDate[1]}`
                        this.dashboard[2].description = `Total of ${this.filterDate[0]} to ${this.filterDate[1]}`
                        this.dashboard[3].description = `Total of ${this.filterDate[0]} to ${this.filterDate[1]}`
                    } else {
                        this.dashboard[0].description = `Total of Logs`
                        this.dashboard[1].description = `Total of the last 7 days`
                        this.dashboard[2].description = `Total of the last 7 days`
                        this.dashboard[3].description = `Total of the last 7 days`
                    }

                    this.isLoading = false

                    if (this.keyword === '') {
                        this.emptyLabel = 'No data in list.'
                    }

                    if (this.keyword !== '' && this.list.length === 0) {
                        this.emptyLabel = `
                            <p class="text-center text-muted">Your search <b class="text-dark">"${this.keyword}"</b> did not match.</p>
                            <p class="text-center text-muted">Please, try another keyword</p>
                        `
                    }
                }
            } else {
                this.isLoading = false
            }
        },

        onSearch() {
            const url = new Url()
            let query = url.buildQuery({ page: 1, keyword: this.keyword, date: this.filterDate, type: this.filterType })

            this.$router
                .push({
                    name: this.$router.currentRoute.name,
                    query
                })
                .catch(error => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    ) {
                        console.log(error)
                    }
                })
        },

        onPageChange(page) {
            var url = new Url()

            this.$router
                .push({
                    name: this.$router.currentRoute.name,
                    query: url.buildQuery({ page })
                })
                .catch(error => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    ) {
                        console.log(error)
                    }
                })
        },

        async countAllType(dateRange) {
            if (!dateRange) {
                dateRange = [this.before7Day(), this.currentDay()]
            }

            const params = {
                date: dateRange
            }

            const countData = await this.$store.dispatch('log/countAllType', params)

            if (countData.status === 200) return countData

            return false
        },

        currentDay() {
            const today = new Date()
            let day = this.numpad(today.getDate())
            let month = this.numpad(today.getMonth() + 1)
            const year = today.getFullYear()

            return `${year}-${month}-${day}`
        },

        before7Day() {
            const today = new Date()
            today.setDate(today.getDate() - 7)
            let day = this.numpad(today.getDate())
            let month = this.numpad(today.getMonth() + 1)
            const year = today.getFullYear()

            return `${year}-${month}-${day}`
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-list-group {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

    > .list-group-item {
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;

        &:last-of-type {
            border-bottom-color: transparent;
        }
    }
}

.theme-dark-mode {
    .list-group-item {
        span {
            filter: brightness(2);
        }
    }
}
</style>
